export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12041.0dd12d80.jpg";